<template>
    <v-dialog v-model="dialog" scrollable max-width="1000px" persistent overlay-opacity="0.75">
        <v-card tile class="grey darken-3">
            <v-app-bar dense color="blue-grey darken-2">
                <v-toolbar-title>{{ label }} Auswahl</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field flat solo dense hide-details label="Suche" prepend-inner-icon="mdi-magnify" background-color="blue-grey darken-3"
                    v-model="search" clearable clear-icon="mdi-close-circle-outline" @click:clear="onSearchClear()" @input="onSearchInput()"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-switch flat solo dense hide-details v-model="checkedOnly" label="Filter"></v-switch>
                <v-spacer></v-spacer>
                <v-btn icon @click="onRefreshData">
                    <v-icon>mdi-reload</v-icon>
                </v-btn>
            </v-app-bar>
            <v-card-text class="ma-0 pa-0" style="height: 700px;">
    <v-data-table 
        :headers="headers"
        :items="filteredItems"
        :search="search"
		item-key="id" item-class="itemclass"
		:page.sync="page"
		:items-per-page="perPage"
        @page-count="pages = $event"
		hide-default-footer
        :single-select="false"
        :show-select="true" selectable-key="notexisting" checkbox-color="black"
        v-model="selected"
		:loading="loading"
		@click:row="onRowClick"
        @item-selected="onItemSelected"
		class="grey darken-3 table-cursor"
    >
		<template v-slot:[`header.data-table-select`]></template>
        <template slot="footer">
			<div class="text-xs-center pt-2">
				<v-pagination color="blue-grey" v-model="page" :length="pages" :total-visible="7" @input="onPageChange()"></v-pagination>
			</div>
		</template>
    </v-data-table>
            </v-card-text>
            <v-divider />
            <v-card-actions>
            <v-btn text class="warning" @click="onCancel()">Abbrechen</v-btn>
            <v-spacer />
            <v-btn v-if="selected.length" text class="success" @click="onSubmit()">Übernehmen</v-btn>
            </v-card-actions>
        </v-card>
        <!-- <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay> -->
		<v-dialog v-model="showmessage">
			<v-toolbar dark color="warning" dense>
				<v-toolbar-title class="white--text">{{ message.title }}</v-toolbar-title>
			</v-toolbar>
			<v-card tile>
				<v-card-text class="red--text" v-html="message.msg"/>
				<v-card-actions>
					<v-spacer />
					<v-btn color="blue" text @click="onMessageClose()">Ok</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>
    </v-dialog>
</template>

<script>
export default {
    name: 'Selector',
    components: {},
    props: {
        label: { type: String, default: null, required: true, },
        table: { type: String, default: null, required: true, },
        existing: { type: Array, default: [], required: true, },
    },
    data: () => ({
        loading: false,
        dialog: false,
        search: null,
        items: [],
        selected: [],
        selectedItem: null,
        checkedOnly: false,
		page: 1,
		pages: 0,
		perPage: 12,
		message: {},
		showmessage: false,
        headers: [
            { text: 'Nr', value: 'tsknr', class: 'blue-grey darken-4', },
            { text: 'Name', value: 'name', class: 'blue-grey darken-4', },
        ],
    }),
    computed: {
        filteredItems() {
            if(this.items) {
                return this.items.filter(item => {
                    return !this.checkedOnly || item.ischecked

                    //if(!this.search) return this.items
                    //return (item.name.toLowerCase().includes(this.search.toLowerCase()))
                })
            } else {return []}
        },
        /*enrichedDesserts() {
            return this.desserts.map(x => ({ ...x, isSelectable: x.calories <= 250 }));
        }*/
    },
    methods: {
        async getData() {
            this.loading = true
			const param = {
				tablename: this.table,
			}
            try {
                await this.$store.dispatch('special/getRefItems', param)
                const result = this.$store.getters['special/getRefItems']( param )
                this.items = result.data
                this.checkExisting()
            } catch (error) {
                console.error(error)
                this.message.title = error.name
                this.message.msg = '<code>' + JSON.stringify(error.message).substring(0, 200) + '</code>'
                this.showmessage = true
            } finally {
                this.loading = false
            }
        },
        onRefreshData() {
            this.items = []
            this.getData()
        },
		onRowClick(e, row) {
			const item = e
            if (row.isSelected) row.select(false);
            else row.select(true);
		},
        onItemSelected(e) {
            const item = e.item
            item.ischecked = e.value
            //item.ischecked = item.ischecked ? true : false
        },
        onSearchInput() {
		},
        onSearchClear() {
            //this.selected = []
            this.page = 1
        },
        onPageChange() {

        },
        onCancel() {
            this.$emit('cancel')
            this.dialog = false
        },
        onSubmit() {
            const newItems = this.selected.filter(e => this.existing.indexOf(e.id) < 0)
            this.$emit('submit', newItems)
            this.dialog = false
        },
		onMessageClose() {
			this.message = {}
			this.showmessage = false			
		},
        checkExisting() {
            this.items.map(e => e.ischecked = this.existing.includes(e.id) ? true : false);
            this.items.map(e => e.notexisting = this.existing.includes(e.id) ? false : true);
            this.items.map(e => e.itemclass = this.existing.includes(e.id) ? 'existing' : '');
            this.selected = this.items.filter(e => this.existing.includes(e.id))
        },
    },
    mounted() {
        //console.log('dialog mounted')
        const param = {
            tablename: this.table,
        }
        const result = this.$store.getters['special/getRefItems']( param )
        if(result) this.items = result.data
        if(!this.items.length) {
            this.getData()
        } else {
            this.checkExisting()
        }
        this.dialog = true
    },
    beforeDestroy() {
        //console.log('destroying dialog')
    },
    watch: {

    },
}
</script>
<style scoped>
.table-cursor >>> tbody tr:hover {
	cursor: pointer;
}
::v-deep tr.v-data-table__selected {
    background: #888144 !important;
}
::v-deep th.text-start {
    background: #263238 !important;  
}
::v-deep tr.v-data-table__selected.existing {
    background: #42402c !important;  
}
</style>